import Vue from 'vue';
import Router from 'vue-router';

import MessageIndex from "@/views/message/MessageIndex";
import Thread from "@/views/message/Thread";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'message-index',
            component: MessageIndex,
        },
        {
            path: '/thread/:threadId',
            name: 'message-thread',
            component: Thread,
        }
    ]
});

export default router;